/* eslint-disable no-bitwise -- string hash for avatar colour */
export const stringToColor = (string: string) => {
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};

export const getInitials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

export const stringAvatar = (name: string) => ({
  sx: {
    bgcolor: stringToColor(name || 'Anonymous'),
    width: 40,
    height: 40,
  },
  children: getInitials(name) || '?',
});
